import type { Namespace } from '../types';

// Logistics (R-074/D-077 — LOG ch. 22). DE drafted — queued for review.
export const logistics = {
  title: { de: 'Logistics', en: 'Logistics' },
  desc: {
    de: 'Lieferaufträge, Kommissionierung, Touren mit Reverse-Load, Cold-Chain und Liefernachweis.',
    en: 'Delivery orders, pick & pack, tours with reverse load, cold chain and proof of delivery.',
  },

  tabOrders: { de: 'Lieferaufträge', en: 'Delivery orders' },
  tabTours: { de: 'Touren', en: 'Tours' },
  tabMyTour: { de: 'Meine Tour', en: 'My tour' },

  // DO status
  stDraft: { de: 'Entwurf', en: 'Draft' },
  stReady: { de: 'Bereit', en: 'Ready' },
  stLoaded: { de: 'Verladen', en: 'Loaded' },
  stInTransit: { de: 'Unterwegs', en: 'In transit' },
  stDelivered: { de: 'Zugestellt', en: 'Delivered' },
  stClosed: { de: 'Abgeschlossen', en: 'Closed' },
  stCancelled: { de: 'Storniert', en: 'Cancelled' },
  // Tour status
  stPlanned: { de: 'Geplant', en: 'Planned' },
  stLoading: { de: 'Beladung', en: 'Loading' },
  stCompleted: { de: 'Abgeschlossen', en: 'Completed' },
  pkgPacked: { de: 'Gepackt', en: 'Packed' },

  // Table headers / fields
  colOrder: { de: 'Auftrag', en: 'Order' },
  colTour: { de: 'Tour', en: 'Tour' },
  colCustomer: { de: 'Kunde', en: 'Customer' },
  colAddress: { de: 'Lieferadresse', en: 'Address' },
  colWindow: { de: 'Zeitfenster', en: 'Window' },
  colStatus: { de: 'Status', en: 'Status' },
  filterAll: { de: 'Alle', en: 'All' },
  customer: { de: 'Kunde', en: 'Customer' },
  contact: { de: 'Kontakt', en: 'Contact' },
  address: { de: 'Lieferadresse', en: 'Delivery address' },
  windowFrom: { de: 'Fenster von', en: 'Window from' },
  windowTo: { de: 'Fenster bis', en: 'Window to' },
  note: { de: 'Notiz', en: 'Note' },
  items: { de: 'Positionen', en: 'Items' },
  batch: { de: 'Charge', en: 'Batch' },
  qtyKg: { de: 'Menge (kg)', en: 'Qty (kg)' },
  addItem: { de: 'Position hinzufügen', en: 'Add item' },
  product: { de: 'Produkt', en: 'Product' },
  orderedKg: { de: 'Bestellt', en: 'Ordered' },
  packedKg: { de: 'Gepackt', en: 'Packed' },
  tour: { de: 'Tour', en: 'Tour' },
  stopN: { de: 'Stopp {n}', en: 'Stop {n}' },
  tourDate: { de: 'Datum', en: 'Date' },
  driver: { de: 'Fahrer', en: 'Driver' },
  vehicle: { de: 'Fahrzeug', en: 'Vehicle' },
  vehiclePlaceholder: { de: 'z. B. Kühltransporter DXB-7741', en: 'e.g. Reefer Van DXB-7741' },
  tempBand: { de: 'Temp-Band', en: 'Temp band' },
  tempMin: { de: 'Temp min (°C)', en: 'Temp min (°C)' },
  tempMax: { de: 'Temp max (°C)', en: 'Temp max (°C)' },
  tempHint: {
    de: 'Cold-Chain-Band; Verstöße lösen einen kritischen Alarm aus. Standard 2–6 °C.',
    en: 'Cold-chain band; breaches raise a critical alarm. Default 2–6 °C.',
  },

  // Actions
  newOrder: { de: 'Neuer Lieferauftrag', en: 'New Delivery Order' },
  newTour: { de: 'Neue Tour', en: 'New Tour' },
  create: { de: 'Anlegen', en: 'Create' },
  save: { de: 'Speichern', en: 'Save' },
  open: { de: 'Öffnen', en: 'Open' },
  colActions: { de: 'Aktionen', en: 'Actions' },
  markReady: { de: 'Bereit melden', en: 'Mark ready' },
  packAction: { de: 'Packen', en: 'Pack' },
  packTitle: { de: 'Paket packen — {product}', en: 'Pack package — {product}' },
  packHint: {
    de: 'Ist-Gewicht je Paket erfassen; die Charge bleibt dem Paket zugeordnet (Traceability).',
    en: 'Record the actual weight per package; the batch stays pinned to the package (traceability).',
  },
  actualWeight: { de: 'Ist-Gewicht (kg)', en: 'Actual weight (kg)' },
  coldChainNote: { de: 'Cold-Chain-Hinweis', en: 'Cold chain note' },
  packages: { de: 'Pakete', en: 'Packages' },
  labelHint: {
    de: 'QR-Label je Paket — scannbar bei Beladung und Zustellung',
    en: 'QR label per package — scannable at loading and delivery',
  },
  itemsEmpty: { de: 'Keine Positionen.', en: 'No items.' },
  ordersEmpty: { de: 'Keine Lieferaufträge.', en: 'No delivery orders.' },
  toursEmpty: { de: 'Keine Touren.', en: 'No tours.' },

  stops: { de: 'Stopps', en: 'Stops' },
  noStops: { de: 'Noch keine Stopps zugeordnet.', en: 'No stops assigned yet.' },
  readyOrders: { de: 'Bereite Aufträge', en: 'Ready orders' },
  assign: { de: 'Zuordnen', en: 'Assign' },
  startLoading: { de: 'Beladung starten', en: 'Start loading' },
  loadingPlan: { de: 'Ladeplan (Reverse Load)', en: 'Loading plan (reverse load)' },
  loadingHint: {
    de: 'Letzter Stopp zuerst laden — jede Ladung per Scan bestätigen',
    en: 'Load the last stop first — confirm each load by scan',
  },
  scanPlaceholder: { de: 'Paketcode scannen/eingeben (PKG-…)', en: 'Scan/enter package code (PKG-…)' },
  loadAction: { de: 'Verladen', en: 'Load' },
  loadRejected: { de: 'Scan abgelehnt', en: 'Scan rejected' },
  unloadedCount: { de: '{n} Paket(e) noch nicht verladen', en: '{n} package(s) not loaded yet' },
  allLoaded: {
    de: 'Alle Pakete verladen — Tour kann starten.',
    en: 'All packages loaded — tour can depart.',
  },
  noPackages: { de: 'Keine Pakete', en: 'No packages' },
  startTour: { de: 'Tour starten', en: 'Depart' },
  completeTour: { de: 'Tour abschließen', en: 'Complete tour' },
  cancelTour: { de: 'Tour stornieren', en: 'Cancel tour' },

  tracking: { de: 'Tracking & Cold Chain', en: 'Tracking & cold chain' },
  time: { de: 'Zeit', en: 'Time' },
  position: { de: 'Position', en: 'Position' },
  temp: { de: 'Temperatur (°C)', en: 'Temperature (°C)' },
  noTracking: { de: 'Noch keine Tracking-Punkte.', en: 'No tracking points yet.' },
  recordTemp: { de: 'Temperatur erfassen', en: 'Record temperature' },

  // Driver view
  myTourEmpty: {
    de: 'Keine aktive Tour. Touren erscheinen hier, sobald die Beladung beginnt.',
    en: 'No active tour. Tours appear here once loading starts.',
  },
  started: { de: 'gestartet', en: 'started' },
  deliverAction: { de: 'Zustellen', en: 'Deliver' },
  podTitle: { de: 'Liefernachweis — {code}', en: 'Proof of delivery — {code}' },
  podHint: {
    de: 'Unterschrift des Empfängers erfassen; Zeitpunkt und Geoposition werden automatisch gespeichert.',
    en: 'Capture the receiver signature; timestamp and geo position are stored automatically.',
  },
  pod: { de: 'Liefernachweis (POD)', en: 'Proof of delivery (POD)' },
  receiver: { de: 'Empfänger', en: 'Receiver' },
  signature: { de: 'Unterschrift', en: 'Signature' },
  clearSignature: { de: 'Löschen', en: 'Clear' },
  confirmDelivery: { de: 'Zustellung bestätigen', en: 'Confirm delivery' },
  deliveredAt: { de: 'Zugestellt am', en: 'Delivered at' },
  geo: { de: 'Geoposition', en: 'Geo position' },

  // Sync (7.10)
  syncPending: { de: 'Ausstehend', en: 'Pending sync' },
  syncOffline: {
    de: 'Offline — Zustellungen werden lokal gesammelt und beim Verbinden übertragen.',
    en: 'Offline — deliveries queue locally and sync on reconnect.',
  },

  // Toasts
  toastOrderCreated: {
    de: '{code} angelegt — Pick&Pack-Aufgabe erzeugt.',
    en: '{code} created — pick & pack task generated.',
  },
  toastOrderCancelled: { de: 'Lieferauftrag storniert.', en: 'Delivery order cancelled.' },
  toastPacked: { de: '{code} gepackt.', en: '{code} packed.' },
  toastReady: { de: 'Auftrag ist bereit zur Auslieferung.', en: 'Order is ready for delivery.' },
  toastTourCreated: { de: '{code} angelegt.', en: '{code} created.' },
  toastAssigned: { de: 'Stopp zugeordnet.', en: 'Stop assigned.' },
  toastUnassigned: { de: 'Stopp entfernt.', en: 'Stop removed.' },
  toastLoadingStarted: {
    de: 'Beladung gestartet — Ladeplan aktiv.',
    en: 'Loading started — loading plan active.',
  },
  toastLoaded: { de: '{code} verladen.', en: '{code} loaded.' },
  toastTourStarted: { de: 'Tour gestartet — Tracking aktiv.', en: 'Tour departed — tracking active.' },
  toastTourCompleted: { de: 'Tour abgeschlossen.', en: 'Tour completed.' },
  toastCompletedUndelivered: {
    de: 'Tour abgeschlossen — {n} Stopp(s) nicht zugestellt, zurück auf „Bereit".',
    en: 'Tour completed — {n} stop(s) undelivered, returned to Ready.',
  },
  toastTourCancelled: { de: 'Tour storniert.', en: 'Tour cancelled.' },
  toastPod: { de: '{code} zugestellt — POD erfasst.', en: '{code} delivered — POD recorded.' },
  toastTempOk: { de: 'Temperatur im Band erfasst.', en: 'Temperature recorded — in band.' },
  toastTempBreach: {
    de: 'Temperatur AUSSERHALB des Bands — Cold-Chain-Alarm ausgelöst.',
    en: 'Temperature OUT of band — cold chain alarm raised.',
  },
  toastQueued: {
    de: 'Offline — Aktion zur Synchronisierung vorgemerkt.',
    en: 'Offline — action queued for sync.',
  },

  // Field placeholders
  phCustomer: { de: 'z. B. Carrefour Mall of the Emirates', en: 'e.g. Carrefour Mall of the Emirates' },
  phContact: { de: 'Telefon oder E-Mail', en: 'Phone or email' },
  phAddress: { de: 'Straße, Gebäude, Stadt', en: 'Street, building, city' },
  phNote: { de: 'Optionale Notiz für den Fahrer', en: 'Optional note for the driver' },
  phBatch: { de: 'Charge wählen', en: 'Select a batch' },
  phQtyKg: { de: 'z. B. 5', en: 'e.g. 5' },
  phDriver: { de: 'Fahrer wählen', en: 'Select a driver' },
  phTempMin: { de: 'z. B. 2', en: 'e.g. 2' },
  phTempMax: { de: 'z. B. 6', en: 'e.g. 6' },
  phWeight: { de: 'z. B. 4,95', en: 'e.g. 4.95' },
  phColdChain: { de: 'z. B. 2–6 °C, Isolierbox', en: 'e.g. 2–6 °C, insulated box' },
  phReceiver: { de: 'Vollständiger Name der unterzeichnenden Person', en: 'Full name of the person signing' },
  phTemp: { de: 'z. B. 4,5', en: 'e.g. 4.5' },
  phScanNote: { de: 'Optionale Notiz', en: 'Optional note' },

  filterStatus: { de: 'Status', en: 'Status' },
  windowInvalid: {
    de: 'Das Fenster muss nach dem Beginn enden.',
    en: 'The window must end after it starts.',
  },
  tempInvalid: { de: 'Minimum muss unter dem Maximum liegen.', en: 'Minimum must be below maximum.' },

  cancelOrderTitle: { de: '{code} stornieren?', en: 'Cancel {code}?' },
  cancelOrderMsg: {
    de: 'Der Auftrag wird storniert und kann weder gepackt noch ausgeliefert werden. Das lässt sich nicht rückgängig machen.',
    en: 'The order is cancelled and can no longer be packed or delivered. This cannot be undone.',
  },
  cancelOrderConfirm: { de: 'Auftrag stornieren', en: 'Cancel order' },
  cancelTourTitle: { de: '{code} stornieren?', en: 'Cancel {code}?' },
  cancelTourMsg: {
    de: 'Die Stopps gehen zurück in „Bereit" und geladene Pakete werden wieder als gepackt geführt. Das lässt sich nicht rückgängig machen.',
    en: 'Its stops go back to Ready and any loaded packages return to packed. This cannot be undone.',
  },

  // My tour
  statDelivered: { de: 'Stopps zugestellt', en: 'Stops delivered' },
  statOnBoard: { de: 'Pakete an Bord', en: 'Packages on board' },
  statLastTemp: { de: 'Letzte Temperatur', en: 'Last temperature' },
  statStarted: { de: 'Tour gestartet', en: 'Tour started' },
  outOfBand: { de: 'Außerhalb des Bereichs', en: 'Out of band' },
  nextStop: { de: 'Nächster Stopp', en: 'Next stop' },
  tourLoadFailed: { de: 'Tourdetails konnten nicht geladen werden.', en: 'Could not load the tour details.' },
} satisfies Namespace;
